import axios from 'axios';


    // let BACKEND_URL_AZURE = 'http://localhost:7071/api/HttpTriggerGetOpenings';
    // let BACKEND_URL_AZURE2 = 'http://localhost:7071/api/HttpTriggerGetMaxTsOpenings';
    // let BACKEND_URL_AZURE3 = 'http://localhost:7071/api/HttpTriggerUpdateOpening?code=Gig4tCcMNZvTACAoEQA8tFrayqztleyvUvOg7IhmXUqzAzFus1Jt6Q==';
    // let BACKEND_URL_AZURE4 = 'http://localhost:7071/api/HttpTriggerNewOpening?code=tUibJqdEFajY2BsP9BxYygoFlOrA3qRx6Cdqkyq5LqTvAzFuCrOxsA==';
    // let BACKEND_URL_AZURE5 = 'http://localhost:7071/api/HttpTriggerDeleteOpening?code=H1XTBDXd-HOh06GIg3CYQH3leRZVChm6Dk48cvNmt8NrAzFuQ2y0vw==';

    let BACKEND_URL_AZURE = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerGetOpenings?code=2gVbmpoEdhMgqNEAND-4xtdMb9s8V_Ilm1rb9SFCLrnFAzFukpQRMA==';
    let BACKEND_URL_AZURE2 = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerGetMaxTsOpenings?code=DBfAw56PAHkbdgIwpaifmtAULH181eqN5GlyDvwPvu7oAzFuQLWJHA==&clientId=default';
    let BACKEND_URL_AZURE3 = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerUpdateOpening?code=Gig4tCcMNZvTACAoEQA8tFrayqztleyvUvOg7IhmXUqzAzFus1Jt6Q==';
    let BACKEND_URL_AZURE4 = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerNewOpening?code=tUibJqdEFajY2BsP9BxYygoFlOrA3qRx6Cdqkyq5LqTvAzFuCrOxsA==';
    let BACKEND_URL_AZURE5 = 'https://heurigenkalender-klosterneuburg-service.azurewebsites.net/api/HttpTriggerDeleteOpening?code=H1XTBDXd-HOh06GIg3CYQH3leRZVChm6Dk48cvNmt8NrAzFuQ2y0vw==';


export async function latestOpeningsUpdateDb() {
    let fetchResult = {
        data: [],
        status: 'unknown'
    };
    try {
        let response = await axios.get(BACKEND_URL_AZURE2);
        fetchResult.status = response.status;
        let lastUpdate = new Date(response.data.data[0].lastUpdate);
        return lastUpdate;
    } catch {
       console.log('http-heurigen/latestOpeningsUpdateDb: ERROR receiving HttpTriggerGetMaxTsOpenings');
    }
}

export async function fetchOpenings() {    
    const openings = [];
    let fetchResult = {
        data: [],
        status: 'unknown'
    };

    try {
        // res.header("Access-Control-Allow-Origin", "*");
        const response = await axios.get(BACKEND_URL_AZURE);
        fetchResult.status = response.status;

        for (let i = 0; i < response.data.data.length; i++) {
                const opening = {
                    id: response.data.data[i].id,
                    idHeuriger: response.data.data[i].idHeuriger,
                    from: (response.data.data[i].from) ? new Date(response.data.data[i].from) : '',
                    to: (response.data.data[i].to) ? new Date(response.data.data[i].to) : '',
                    remarks: response.data.data[i].remarks,
                    deleted: response.data.data[i].deleted,
                    _ts: response.data.data[i]._ts                    
                }
                openings.push(opening)
            }
        fetchResult.data = openings;
    } catch {
        console.log('http-openings/fetchOpenings: ERROR receiving HttpTriggerGetMaxTsOpenings');
    }
    
    return fetchResult;
}

export async function updateOpening(opening) {    
    let response = await axios.post(BACKEND_URL_AZURE3, opening);
    // console.log('response updateOpening', response);
}

export async function newOpening(opening, token) {    
    if(token) {
        await axios.interceptors.request.use(async (config) => {    
            config.headers.Authorization = token;        
            return config;
          });
        let response = await axios.post(BACKEND_URL_AZURE4, opening);
    } else {
        console.log('newOpening no token provided, cancelling');
    }
    // console.log('response newOpening', response);
}

export async function deleteOpening(opening, token) {    
    // console.log('deleteOpening token', token);
    if(token) {        
        await axios.interceptors.request.use(async (config) => {    
            config.headers.Authorization = token;        
            return config;
          });
        let response = await axios.post(BACKEND_URL_AZURE5, opening);
        console.log('response deleteOpening', response);
    } else {
        console.log('deleteOpening no token provided, cancelling');
    }
    
}